module.exports = __webpack_public_path__ + "img/checklist-contours-verts.svg";